import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { TbLicense } from "react-icons/tb";
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Aegis Construction</h3>
            <p>{t('about.subtitle')}</p>
          </div>

          <div className="footer-section">
            <h4>{t('footer.contact')}</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <FaPhone />
                <span>(514) 677-5977</span>
              </div>
              <div className="contact-item">
                <FaEnvelope />
                <span>info@aegisconstruction.ca</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span>Montreal, Quebec</span>
              </div>
              <div className="contact-item">
                <TbLicense />
                <span>RBQ # 5860-0628-01</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>{t('nav.services')}</h4>
            <ul className="footer-links">
              <li>{t('services.projectManagement')}</li>
              <li>{t('services.residential')}</li>
              <li>{t('services.commercial')}</li>
              <li>{t('services.renovations')}</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('contact.followUs')}</h4>
            <div className="social-links">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Aegis Construction. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;